import { css } from 'styled-components';
import token from 'styled-token';
import { disabledMixin } from '../disabledMixin';
import { focusMixin } from '../focusMixin';
import { radioStateMixin } from '../radioStateMixin';
import { spacingMixin } from '../spacingMixin';
var offscreenCSS = function offscreenCSS(_ref) {
  var offscreen = _ref.offscreen;
  if (!offscreen) {
    return '';
  }
  return "\n      && {\n          position: absolute;\n          left: -99999px;\n      }\n  ";
};
var zsgCSS = token({
  fontColorLabel: 'colors.textDark',
  size: 'Radio.size'
}, function (_ref2) {
  var fontColorLabel = _ref2.fontColorLabel,
    size = _ref2.size;
  return css(["input&{position:static;height:", "px;width:", "px;}input& + label{padding-left:0;&:hover{color:", ";}}input& + label:before,input&:checked + label:after{content:none;}"], size, size, fontColorLabel);
});

/** @class RadioMixin */
/** @method */
export var RadioMixin = function RadioMixin(props) {
  return css(["", " ", " &:hover:not(:disabled){", "}&:active:not(:disabled){", "}&:checked{", "}&:disabled{", "}", " ", " ", ""], zsgCSS(props), radioStateMixin()(props), radioStateMixin('hover')(props), radioStateMixin('pressed')(props), radioStateMixin('checked')(props), disabledMixin(Object.assign({}, props, {
    disabled: true
  })), focusMixin(props), offscreenCSS(props), spacingMixin(props));
};